import React from "react";
import BrandedForgotPassword from "@/pages/branded/BrandedForgotPassword";

const BRAND = {
  name: "Management USA NJ",
  tagline: "Worker portal",
  apiPrefix: "/worker",
  loginPath: "/managementusa",
};

export default function WorkerForgotPassword() {
  return <BrandedForgotPassword brand={BRAND} testidPrefix="worker-forgot" />;
}
